// extracted by mini-css-extract-plugin
export default {"root":"_290hN","menu":"_3d8bG"};